import { FichaAnexoRemocaoView } from "./view-ficha-anexo-remocao";
import type { FichaAnexoRemocaoProps } from "./types-ficha-anexo-remocao";

/** Confirmação de remoção do anexo: sem lógica, só a View. */
export function FichaAnexoRemocao(props: FichaAnexoRemocaoProps) {
  return <FichaAnexoRemocaoView {...props} />;
}

export type * from "./types-ficha-anexo-remocao";
